import './BrowserAlert.scss'

function BrowserAlert(props: any) {
    return <>
        <div className="browser-alert">
            🚨 لطفا حتما از مرورگر <span className="font-bold">کروم</span> استفاده کنید و از طریق لینک های ارسال شده در تلگرام، اپلیکیشن را باز نکنید.
        </div>
    </>
}

export default BrowserAlert;